// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Loader = () => {
    const repeat = [0,1,2,3,4,5];
    return(
        <>
        {repeat.map((_, index) => (
            <figure key={index} className="flex h-full flex-grow basis-[calc((100%/2)-(5*10px))]  sm:basis-[calc((100%/3)-(5*10px))] lg:basis-[calc((100%/6)-(5*10px))] transition-all ease-in-out duration-300 cursor-crosshair rounded-3xl overflow-hidden">
            <div
              className="flex h-full aspect-[55/93] w-full justify-center rounded-md bg-neutral-50 motion-safe:animate-pulse dark:bg-neutral-900"
              aria-hidden="true"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
                className="size-12 self-center fill-neutral-600/10 dark:fill-neutral-300/10"
              >
                <path
                  fillRule="evenodd"
                  d="M1 5.25A2.25 2.25 0 0 1 3.25 3h13.5A2.25 2.25 0 0 1 19 5.25v9.5A2.25 2.25 0 0 1 16.75 17H3.25A2.25 2.25 0 0 1 1 14.75v-9.5Zm1.5 5.81v3.69c0 .414.336.75.75.75h13.5a.75.75 0 0 0 .75-.75v-2.69l-2.22-2.219a.75.75 0 0 0-1.06 0l-1.91 1.909.47.47a.75.75 0 1 1-1.06 1.06L6.53 8.091a.75.75 0 0 0-1.06 0l-2.97 2.97ZM12 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
          </figure>
          ))}
        </>
    )
}

const TeamCard = ({ img_url, title, description, position, num_of_cards }) => {

    const [modalOpen, setModalOpen] = useState(false); 
    function handleOpenModal(){
        if(modalOpen === false){
            document.getElementsByTagName('body')[0].style.overflow = 'hidden';
            setModalOpen(true);
        }else{
            document.getElementsByTagName('body')[0].style.overflow = '';
            setModalOpen(false);
        }
    }   

    const textVariants = { hidden: { opacity: 0}, visible: { opacity: 1, transition: { opacity: { duration: 0.2, delay: 0.1 } }} };

    const backdropVariants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { duration: 0.15, ease: 'easeInOut' } },
        exit: { opacity: 0, transition: { duration: 0.15, ease: 'easeInOut' } }
    };    

    const modalVariants = {
        hidden: { opacity: 0, y: 50, scale:0.95, transition: { duration: 0.2, ease: 'easeInOut' } },
        visible: { opacity: 1, y: 0, scale:1, transition: { duration: 0.2, ease: 'easeInOut' } },
        exit: { opacity: 0, y: 50, scale:0.95, transition: { duration: 0.2, ease: 'easeInOut' } },
   };

    return (
        <>
        <motion.figure 
            className={`block h-full relative flex-grow basis-[calc((100%/2)-(5*10px))] lg:basis-[calc((100%/${num_of_cards})-(5*10px))] lg:hover:basis-[25%] transition-all duration-300 delay-0 cursor-crosshair rounded-[--radius_24] overflow-hidden`}
            whileHover="visible"
            initial="hidden"
            onClick={handleOpenModal}
        >
            <motion.div
                className="absolute bottom-0 left-0 z-10 w-full pl-4 pb-8 md:pl-6 md:pb-12 pt-7 team_card_gradient"
                variants={textVariants}
            >             
                <h2 className='text_31 font-title font-bold text-white'>{title}</h2>
                <small className='font-bold font-title text_18 text-white'>{position}</small>
            </motion.div>          
            <img 
                className="w-full h-full transition-all object-cover grayscale hover:grayscale-0" 
                src={img_url} 
                alt="Team member"
            />
        </motion.figure>

        <AnimatePresence>
        {modalOpen && (
            <motion.aside layout 
            variants={backdropVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            onAnimationComplete={console.log('[+] Animation complete')}

            onClick={handleOpenModal}
            className='flex justify-center backdrop-blur-sm items-center fixed top-0 left-0 w-full h-screen bg-black bg-opacity-20 z-[9999]'>

            <motion.div 
            variants={modalVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            onClick={(e) => e.stopPropagation()}
            className='bg-white dark:bg-zuriq-dark w-full h-screen sm:h-auto sm:max-w-[600px] px-9 md:px-12 py-16 md:py-20 sm:rounded-[--radius_24] shadow-md relative border border-black border-opacity-10'>
                <motion.div 
                whileHover={{
                    scale: 1.08,        // Slight scaling effect
                    rotate: 15,        // Slight rotation on hover
                    backgroundColor: "#ff5f5f",  // Change color
                }}
                onClick={handleOpenModal} 
                role="button" className='size-10 bg-zuriq-primary rounded-full absolute top-2 right-2 sm:-top-5 sm:-right-5'>
                    <svg className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2' width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                      <mask id="mask0_210_113"style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x={0} y={0} width={24} height={24}>
                        <rect width={24} height={24} fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_210_113)">
                        <path
                          d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                </motion.div>
                <header className='flex items-center gap-3.5'>
                    <figure className='size-20 md:size-24 rounded-full overflow-hidden'>
                        <img className='w-full h-full object-cover' src={img_url}/>
                    </figure>
                    <div className='flex flex-col'>
                        <span className='font-title font-bold text_31'>{title}</span>
                        <span className='font-bold font-title text_18'>{position}</span>
                    </div>
                </header>
                <div className='mt-6'>
                    <p className='text-lg text-black dark:text-white tracking-tight'>
                        {description}
                    </p>
                </div>
            </motion.div>

            </motion.aside>
        )}
        </AnimatePresence>
        </>
    );
}


function TeamCards() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [cardData, setCardData] = useState([]);

    useEffect(() => {
        try {
            //Parse Team Cards
            const team_data = document.getElementById('team-data-json');
            const team_data_json = team_data.textContent.trim();
            const parser = new DOMParser();
            const doc = parser.parseFromString(team_data_json, 'text/html');
            const kg_cards = doc.querySelectorAll('.kg-card');
            
            if (kg_cards.length === 0) throw new Error('Error during rendering team cards');
            let card_data = [];
            kg_cards.forEach((item) => {
                const img_ = item.querySelector('img');
                const title = item.querySelector('.kg-product-card-title');
                const description = item.querySelector('.kg-product-card-description');
                const position = description.querySelector('strong');
                let position_text = '';
                if(position){
                    position.remove();
                    position_text = position.innerText;
                }
                card_data.push({img:img_.src, title:title.innerText, description: description.innerText, position:position_text});
            });
            setCardData(card_data);
            setTimeout(()=>{setLoading(false);},400);                
            
        } catch (err) {
            console.log('[x] Err -> ', err.message);
            setError(true);
        }
    }, []);

    return (
        <>
            {error && (
                <div className="flex justify-center items-center h-full w-full">
                    <p className='text-red-400 py-3'>Error loading team cards</p>
                </div>
            )}
            {loading && (
                <div className="flex flex-wrap lg:flex-nowrap justify-center items-center h-full w-full max-w-full lg:aspect-[1702/465] gap-[10px]">
                    <Loader />
                </div>
            )}

            {!loading && !error && (
                <div className="flex flex-wrap lg:flex-nowrap justify-center items-center h-full w-full max-w-full lg:aspect-[1702/465] gap-[10px]">
                    {cardData.map((item, index) => (
                        <TeamCard key={index} img_url={item.img} title={item.title} description={item.description} position={item.position} num_of_cards={cardData.length}/>
                    ))}                    
                </div>
            )}

   
        </>
    );
}

export default TeamCards;


